import store from '@/store'

export default {
  methods: {
    snackbar({ text = '', open = true, timeout = 3000, color = 'grey darken-2', x = null, y = 'bottom', icon = null }) {
      store.dispatch('snackbar/snackbar', { text, open, timeout, color, x, y, icon })
    },
    spinner(state) {
      this.$root.spinners.main = state
    },
    openResourcePicker() {
      this.$root.resourcePicker.status = true
    },
    swal({ type = 'success', title, text, cancelButtonText, confirmButtonText = 'Okay', timer }) {
      return this.$swal({
        title: title,
        text: text,
        icon: type,
        showCancelButton: !!cancelButtonText,
        confirmButtonText: confirmButtonText,
        cancelButtonText: cancelButtonText,
        timer
      })
    },
    openDeleteModal({ title, description, callback, eventName }) {
      this.$root.deleteModal.status = true
      this.$root.deleteModal.title = title
      this.$root.deleteModal.description = description || 'Are you sure you want to proceed? This action is not reversible.'
      this.$root.deleteModal.callback = callback
      this.$root.deleteModal.eventEmitOnSuccess = eventName || 'item-deleted'
    }
  }
}
